import Vue from 'vue';
import VueRouter from 'vue-router';
import tools from '@/api/tools';
import common from '@/api/common';
import appTools from '@/api/app';
Vue.use(VueRouter);

const routes = [
  {
    path: '/apps/index',
    name: 'index',
    component: () => import('@/pages/apps/index'),
    meta: {
      title: '我的商城'
    }
  },
  {
    path: '/apps/login',
    name: 'login',
    component: () => import('@/pages/apps/login'),
    meta: {
      title: '登录'
    }
  },
  {
    path: '/apps/selectMerchant',
    name: 'selectMerchant',
    component: () => import('@/pages/apps/selectMerchant'),
    meta: {
      title: '请选择要登录的企业'
    }
  },
  {
    path: '/apps/insteadTbLogin',
    name: 'insteadTbLogin',
    component: () => import('@/pages/apps/insteadTbLogin'),
    meta: {
      title: '登录'
    }
  },
  {
    path: '/apps/register',
    name: 'register',
    component: () => import('@/pages/apps/register'),
    meta: {
      title: '在线增员'
    }
  },
  {
    path: '/apps/phoneValid',
    name: 'phoneValid',
    component: () => import('@/pages/apps/loginAuth/phoneValid'),
    meta: {
      title: '安全验证'
    }
  },
  {
    //首次登录强制重置密码
    path: '/apps/resetPwd',
    name: 'resetPwd',
    component: () => import('@/pages/apps/loginAuth/resetPwd'),
    meta: {
      title: '重置密码'
    }
  },
  {
    path: '/apps/jump',
    name: 'apps.jump',
    component: () => import('@/pages/apps/other/jump'),
    meta: {
      title: '加载中'
    }
  },
  {
    path: '/apps/other/productDetail',
    name: 'apps.other.productDetail',
    component: () => import('@/pages/apps/other/productDetail'),
    meta: {
      title: '加载中'
    }
  },
  {
    path: '/apps/loginByCode',
    name: 'loginByCode',
    component: () => import('@/pages/apps/loginByCode'),
    meta: {
      title: '验证码登录'
    }
  },
  {
    path: '/apps/loginByCodeTbLogin',
    name: 'loginByCodeTbLogin',
    component: () => import('@/pages/apps/loginByCodeTbLogin'),
    meta: {
      title: '验证码登录'
    }
  },
  {
    path: '/apps/fileView',
    name: 'apps.fileView',
    component: () => import('@/pages/apps/other/fileView'),
    meta: {
      title: ' '
    }
  },
  /*************** 产品相关 *******************/
  {
    path: '/apps/product',
    name: 'product.list',
    component: () => import('@/pages/apps/product/list'),
    meta: {
      title: '产品库',
      keepAlive: true,
      deepth: 1
    }
  },
  {
    path: '/apps/groupList',
    name: 'groupList.list',
    component: () => import('@/pages/apps/product/groupList'),
    meta: {
      title: '团财产品库',
      keepAlive: true,
      deepth: 1
    }
  },
  {
    path: '/apps/returnVisit',
    name: 'apps.returnVisit',
    component: () => import('@/pages/apps/returnVisit/index'),
    meta: {
      title: '回执回访管理',
      keepAlive: true
    }
  },
  /*************** 订单相关 *******************/
  {
    path: '/apps/order',
    name: 'order.list',
    component: () => import('@/pages/apps/order/list'),
    meta: {
      title: '我的订单'
    }
  },
  {
    path: '/apps/order/detail',
    name: 'order.detail',
    component: () => import('@/pages/apps/order/detail'),
    meta: {
      title: '详情',
      deepth: 3
    }
  },
  {
    path: '/apps/order/orderDetail',
    name: 'orderDetail.detail',
    component: () => import('@/pages/apps/order/orderDetail'),
    meta: {
      title: '详情',
      deepth: 3
    }
  },
  {
    path: '/apps/order/bzqy',
    name: 'order.bzqy',
    component: () => import('@/pages/apps/order/bzqy'),
    meta: {
      title: '保障权益'
    }
  },
  {
    path: '/apps/order/group/securityRecord',
    name: 'order.group.securityRecord',
    component: () => import('@/pages/apps/order/group/securityRecord'),
    meta: {
      title: '保全记录'
    }
  },
  {
    path: '/apps/order/serviceDetail',
    name: 'order.serviceDetail',
    component: () => import('@/pages/apps/order/serviceDetail'),
    meta: {
      title: '服务费详情'
    }
  },
  {
    path: '/apps/order/orderServiceDetail',
    name: 'order.orderServiceDetail',
    component: () => import('@/pages/apps/order/orderServiceDetail'),
    meta: {
      title: '服务费详情'
    }
  },
  {
    path: '/apps/order/giftList',
    name: 'order.giftList',
    component: () => import('@/pages/apps/order/giftList'),
    meta: {
      title: '0元投保订单'
    }
  },
  {
    path: '/apps/order/index',
    name: 'order.order.index',
    component: () => import('@/pages/apps/order/order'),
    meta: {
      title: '我的订单',
      deepth: 1,
      keepAlive: true
    }
  },

  {
    path: '/apps/order/search',
    name: 'order.order.search',
    component: () => import('@/pages/apps/order/search'),
    meta: {
      title: '',
      deepth: 2,
      keepAlive: true
    }
  },
  {
    path: '/apps/groupOrder',
    name: 'order.groupOrder',
    component: () => import('@/pages/apps/order/group/list'),
    meta: {
      title: '团财险',
      deepth: 1,
      keepAlive: true
    }
  },
  {
    path: '/apps/groupOrder/search',
    name: 'order.groupOrder.search',
    component: () => import('@/pages/apps/order/group/search'),
    meta: {
      title: '团财险',
      deepth: 2,
      keepAlive: true
    }
  },
  {
    path: '/apps/groupOrder/detail',
    name: 'groupOrder.detail',
    component: () => import('@/pages/apps/order/group/detail'),
    meta: {
      title: '详情',
      deepth: 3,
      keepAlive: true
    }
  },
  {
    path: '/apps/groupOrder/endorsementDetail',
    name: 'groupOrder.endorsementDetail',
    component: () => import('@/pages/apps/order/group/endorsementDetail'),
    meta: {
      title: '批单详情',
      deepth: 4,
      keepAlive: true
    }
  },
  // 团险保单服务费详情
  {
    path: '/apps/groupOrder/serviceDetail',
    name: 'groupOrder.serviceDetail',
    component: () => import('@/pages/apps/order/group/serviceDetail'),
    meta: {
      title: '服务费明细',
      deepth: 4
    }
  },
  {
    path: '/apps/groupOrder/insureList',
    name: 'groupOrder.insureList',
    component: () => import('@/pages/apps/order/group/insureList'),
    meta: {
      title: '被保险人清单',
      deepth: 4
    }
  },
  {
    path: '/apps/order-ok',
    name: 'customerPolicy.list',
    component: () => import('@/pages/apps/customerPolicy/order'),
    meta: {
      //ok保保单、订单
      title: ''
    }
  },
  {
    path: '/apps/underwriting',
    name: 'underwriting',
    component: () => import('@/pages/apps/customerPolicy/underwriting'),
    meta: {
      title: '核保管理'
    }
  },
  {
    path: '/apps/order/policyList',
    name: 'order.policyList',
    component: () => import('@/pages/apps/order/policyList'),
    meta: {
      title: '保单列表'
    }
  },
  /*************** 我的相关 *******************/
  {
    path: '/apps/my',
    name: 'my.index',
    component: () => import('@/pages/apps/my/my'),
    meta: {
      title: '个人中心'
    }
  },
  {
    path: '/apps/my/setting',
    name: 'my.setting',
    component: () => import('@/pages/apps/my/setting'),
    meta: {
      title: '账户设置'
    }
  },
  {
    path: '/apps/my/resetPwd',
    name: 'my.resetPwd',
    component: () => import('@/pages/apps/my/resetPwd'),
    meta: {
      title: '重置密码'
    }
  },
  {
    path: '/apps/my/updatePwd',
    name: 'my.updatePwd',
    component: () => import('@/pages/apps/my/updatePwd'),
    meta: {
      title: '修改密码'
    }
  },
  {
    path: '/apps/my/bankSet',
    name: 'my.bankSet',
    component: () => import('@/pages/apps/my/bankSet'),
    meta: {
      title: '银行卡绑定'
    }
  },
  {
    path: '/apps/my/upstreamNum',
    name: 'my.upstreamNum',
    component: () => import('@/pages/apps/my/upstreamNum'),
    meta: {
      title: '上游工号'
    }
  },
  {
    path: '/apps/my/contractList',
    name: 'my.contractList',
    component: () => import('@/pages/apps/my/contractList'),
    meta: {
      title: '合同列表'
    }
  },
  {
    path: '/apps/my/relationship',
    name: 'my.relationship',
    component: () => import('@/pages/apps/my/relationship'),
    meta: {
      title: '关系查询'
    }
  },
  /*************** 课程培训 *******************/
  // ok保外部培训页面
  {
    path: '/apps/course/trainSysLogin',
    name: 'apps.course.trainSysLogin',
    component: () => import('@/pages/apps/course/trainSysLogin'),
    meta: {
      title: '培训中心'
    }
  },
  {
    path: '/apps/course/curriculumCenter',
    name: 'apps.course.curriculumCenter',
    component: () => import('@/pages/apps/course/curriculumCenter'),
    meta: {
      title: '培训中心',
      rank: 2,
      deepth: 1,
      keepAlive: true
    }
  },
  {
    path: '/apps/course/courseDetails',
    name: 'apps.course.courseDetails',
    component: () => import('@/pages/apps/course/courseDetails'),
    meta: {
      title: '课程详情',
      rank: 2,
      deepth: 3
    }
  },
  {
    path: '/apps/course/excelFileList',
    name: 'apps.course.excelFileList',
    component: () => import('@/pages/apps/course/excelFileList'),
    meta: {
      title: '课程详情'
    }
  },
  {
    path: '/apps/course/learningRecords',
    name: 'apps.course.learningRecords',
    component: () => import('@/pages/apps/course/learningRecords'),
    meta: {
      title: '学习记录',
      rank: 2,
      deepth: 1,
      keepAlive: true
    }
  },
  {
    path: '/apps/course/homeworkAfterClass',
    name: 'courseHomeworkAfterClass',
    component: () => import('@/pages/apps/course/homeworkAfterClass'),
    meta: {
      title: '课后作业',
      rank: 2
    }
  },
  /*************** 云学院新版 *******************/
  {
    path: '/apps/newMaterial',
    name: 'apps.newMaterial',
    component: () => import('@/pages/apps/newMaterial/material'),
    meta: {
      title: '展业素材',
      keepAlive: true
    }
  },
  {
    path: '/apps/newMaterial/poster',
    name: 'apps.newMaterial.poster',
    component: () => import('@/pages/apps/newMaterial/components/poster'),
    meta: {
      title: '海报'
    }
  },
  {
    path: '/apps/newMaterial/seriesVideo',
    name: 'apps.newMaterial.seriesVideo',
    component: () => import('@/pages/apps/newMaterial/seriesVideo'),
    meta: {
      title: '系列视频',
      keepAlive: true
    }
  },
  {
    path: '/apps/newMaterial/newPoster',
    name: 'apps.newMaterial.newPoster',
    component: () => import('@/pages/apps/newMaterial/components/newPoster'),
    meta: {
      title: '海报'
    }
  },
  {
    path: '/apps/newMaterial/detail',
    name: 'apps.newMaterial.detail',
    component: () => import('@/pages/apps/newMaterial/detail'),
    meta: {
      title: '产品资料'
    }
  },
  {
    path: '/apps/newMaterial/dataDetail',
    name: 'apps.newMaterial.dataDetail',
    component: () => import('@/pages/apps/newMaterial/dataDetail'),
    meta: {
      title: '资料详情'
    }
  },
  {
    path: '/apps/newMaterial/returnVisitGuidelines',
    name: 'apps.newMaterial.returnVisitGuidelines',
    component: () => import('@/pages/apps/newMaterial/returnVisitGuidelines'),
    meta: {
      title: '回执回访指引'
    }
  },
  {
    path: '/apps/newMaterial/fileList',
    name: 'apps.newMaterial.fileList',
    component: () => import('@/pages/apps/newMaterial/fileList'),
    meta: {
      title: '产品条款'
    }
  },
  {
    path: '/apps/newMaterial/searchPage',
    name: 'apps.searchPage',
    component: () => import('@/pages/apps/newMaterial/components/searchPage'),
    meta: {
      title: '搜索页',
      keepAlive: true
    }
  },
  {
    path: '/apps/newMaterial/coursewareList',
    name: 'apps.newMaterial.coursewareList',
    component: () => import('@/pages/apps/newMaterial/coursewareList'),
    meta: {
      title: '课件'
    }
  },
  {
    path: '/apps/articelDetail',
    name: 'apps.articelDetail',
    component: () => import('@/pages/apps/newMaterial/articelDetail'),
    meta: {
      title: '文章详情'
    }
  },
  {
    path: '/apps/newArticelDetail',
    name: 'apps.newArticelDetail',
    component: () => import('@/pages/apps/newMaterial/newArticelDetail'),
    meta: {
      title: '文章详情'
    }
  },
  {
    path: '/apps/strategyDetail',
    name: 'apps.strategyDetail',
    component: () => import('@/pages/apps/newMaterial/components/strategyDetail'),
    meta: {
      title: '文章详情'
    }
  },
  {
    path: '/apps/newMaterial/downloadFile',
    name: 'apps.newMaterial.downloadFile',
    component: () => import('@/pages/apps/newMaterial/downloadFile'),
    meta: {
      title: '请在浏览器中打开'
    }
  },
  /*************** 结算相关 *******************/
  {
    path: '/apps/settlement/closeGeneral',
    name: 'settlement.closeGeneral',
    component: () => import('@/pages/apps/settlement/closeGeneral'),
    meta: {
      title: '结算概况'
    }
  },
  {
    path: '/apps/settlement/overview',
    name: 'settlement.overview',
    component: () => import('@/pages/apps/settlement/overview'),
    meta: {
      title: '结算概览'
    }
  },
  // 如意保保结算概况
  {
    path: '/apps/settlement/overview-ruyi',
    name: 'settlement.overview-ruyi',
    component: () => import('@/pages/apps/settlement/overview-ruyi'),
    meta: {
      title: '结算概览'
    }
  },
  // ok保提现
  // // 旧版ok保提现
  {
    path: '/apps/settlement/overview-ok',
    name: 'settlement.overview.ok',
    component: () => import('@/pages/apps/settlement/okBao/overview-ok'),
    meta: {
      title: '提现记录'
    }
  },
  // 新版本ok保提现,上线后旧版本可以删
  {
    path: '/apps/settlement/overview-ok-new',
    name: 'settlement.overview.ok.new',
    component: () => import('@/pages/apps/okBao/settlement/overview'),
    meta: {
      title: '提现收入'
    }
  },
  {
    path: '/apps/settlement/overviewConfirm',
    name: 'settlement.overview.ok.overviewConfirm',
    component: () => import('@/pages/apps/settlement/okBao/overviewConfirm'),
    meta: {
      title: '账单确认'
    }
  },
  {
    path: '/apps/settlement/withdrawal-ok',
    name: 'settlement.withdrawal-ok',
    component: () => import('@/pages/apps/settlement/okBao/withdrawal-ok'),
    meta: {
      title: '申请提现'
    }
  },
  // ok保提现 end
  {
    path: '/apps/settlement/withdrawal',
    name: 'settlement.withdrawal',
    component: () => import('@/pages/apps/settlement/withdrawal'),
    meta: {
      title: '申请提现'
    }
  },
  {
    path: '/apps/settlement/incomeListPage0',
    name: 'settlement.incomeListPage0',
    component: () => import('@/pages/apps/settlement/incomeListPage'),
    meta: {
      title: '待结算费用'
    }
  },
  {
    path: '/apps/settlement/incomeListPage1',
    name: 'settlement.incomeListPage1',
    component: () => import('@/pages/apps/settlement/incomeListPage'),
    meta: {
      title: '未发放费用'
    }
  },
  {
    path: '/apps/settlement/incomeListPage2',
    name: 'settlement.incomeListPage2',
    component: () => import('@/pages/apps/settlement/incomeListPage'),
    meta: {
      title: '已发放费用'
    }
  },
  {
    path: '/apps/settlement/incomeDetailPage',
    name: 'settlement.incomeDetailPage',
    component: () => import('@/pages/apps/settlement/incomeDetailPage'),
    meta: {
      title: '明细'
    }
  },
  {
    path: '/apps/settlement/incomeDetailPage1',
    name: 'settlement.incomeDetailPage1',
    component: () => import('@/pages/apps/settlement/incomeDetailPage1'),
    meta: {
      title: '待结算明细',
      deepth: 1,
      keepAlive: true
    }
  },
  {
    path: '/apps/settlement/okBao/incomeDetailPage1',
    name: 'settlement.okBao.incomeDetailPage1',
    component: () => import('@/pages/apps/settlement/okBao/incomeDetailPage1'),
    meta: {
      title: '待结算明细',
      deepth: 1,
      keepAlive: true
    }
  },
  /********销售支持**********/
  {
    path: '/apps/settlement/okBao/salesSupport',
    name: 'settlement.okBao.salesSupport',
    component: () => import('@/pages/apps/settlement/okBao/salesSupport'),
    meta: {
      title: '联系销售支持'
    }
  },
  {
    path: '/apps/settlement/incomeDetailPage2',
    name: 'settlement.incomeDetailPage2',
    component: () => import('@/pages/apps/settlement/incomeDetailPage2'),
    meta: {
      // title: "税后合计",
    }
  },
  {
    path: '/apps/settlement/policyDetail',
    name: 'settlement.incomeDetail.policyDetail',
    component: () => import('@/pages/apps/settlement/incomeDetail/policyDetail.vue'),
    meta: {}
  },
  {
    path: '/apps/settlement/baseCommisionPolicy',
    name: 'settlement.incomeDetail.baseCommisionPolicy',
    component: () => import('@/pages/apps/settlement/incomeDetail/baseCommisionPolicy.vue'),
    meta: {}
  },
  {
    path: '/apps/settlement/xlhManageDetailQuery',
    name: 'settlement.incomeDetail.xlhManageDetailQuery',
    component: () => import('@/pages/apps/settlement/incomeDetail/xlhManageDetailQuery.vue'),
    meta: {}
  },
  {
    path: '/apps/settlement/rankCommissionDetail',
    name: 'settlement.incomeDetail.rankCommissionDetail',
    component: () => import('@/pages/apps/settlement/incomeDetail/rankCommissionDetail.vue'),
    meta: {}
  },
  {
    path: '/apps/settlement/fycDetail',
    name: 'settlement.incomeDetail.fycDetail',
    component: () => import('@/pages/apps/settlement/incomeDetail/fycDetail.vue'),
    meta: {}
  },
  {
    path: '/apps/settlement/grantDetailPage',
    name: 'settlement.grantDetailPage',
    component: () => import('@/pages/apps/settlement/grantDetailPage'),
    meta: {
      title: '明细'
    }
  },
  {
    path: '/apps/settlement/policy',
    name: 'settlement.policy',
    component: () => import('@/pages/apps/settlement/policy'),
    meta: {
      title: '结算保单'
    }
  },
  {
    path: '/apps/settlement/cashOut',
    name: 'settlement.cashOut',
    component: () => import('@/pages/apps/settlement/cashOut'),
    meta: {
      title: '提现'
    }
  },
  {
    path: '/apps/settlement/cashOutRecord',
    name: 'settlement.cashOut.cashOutRecord',
    component: () => import('@/pages/apps/settlement/cashOutRecord'),
    meta: {
      title: '提现记录'
    }
  },
  {
    path: '/apps/settlement/confirmedWithdrawal',
    name: 'settlement.confirmedWithdrawal',
    component: () => import('@/pages/apps/settlement/confirmedWithdrawal'),
    meta: {
      title: '确认提现'
    }
  },
  {
    path: '/apps/settlement/achievement',
    name: 'settlement.achievement',
    component: () => import('@/pages/apps/settlement/achievement'),
    meta: {
      title: '本月业绩'
    }
  },
  {
    path: '/apps/settlement/ownAchievement',
    name: 'settlement.ownAchievement',
    component: () => import('@/pages/apps/settlement/ownAchievement'),
    meta: {
      title: ''
    }
  },
  {
    path: '/apps/settlement/teamAchievement',
    name: 'settlement.teamAchievement',
    component: () => import('@/pages/apps/settlement/teamAchievement'),
    meta: {
      title: '团队业绩'
    }
  },
  {
    path: '/apps/intellOrderInfo/:id?',
    component: () => import('@/pages/apps/other/intellOrderInfo'),
    name: 'intellOrderInfo',
    meta: {
      title: '人工核保'
    }
  },
  {
    path: '/apps/settlement/okBao/confirmedWithdrawal',
    name: 'settlement.okBao.confirmedWithdrawal',
    component: () => import('@/pages/apps/settlement/okBao/confirmedWithdrawal'),
    meta: {
      title: '确认提现',
      deepth: 4
    }
  },
  {
    path: '/apps/settlement/deductIncomeDetail',
    name: 'settlement.deductIncomeDetail',
    component: () => import('@/pages/apps/settlement/incomeDetail/deductIncomeDetail'),
    meta: {
      title: '基本法扣款'
    }
  },
  /*************** 客户管理 *******************/
  {
    path: '/apps/customer',
    name: 'apps.customer',
    component: () => import('@/pages/apps/customer/customer'),
    meta: {
      title: '客户管理',
      keepAlive: true
    }
  },
  {
    path: '/apps/customer/porduct',
    name: 'apps.customer.porduct',
    component: () => import('@/pages/apps/customer/porduct'),
    meta: {
      title: '产品访客',
      keepAlive: true
    }
  },
  {
    path: '/apps/customer/visitList',
    name: 'apps.customer.visitList',
    component: () => import('@/pages/apps/customer/visitList'),
    meta: {
      title: '全部访客',
      keepAlive: true
    }
  },
  {
    path: '/apps/customer/visitDetail',
    name: 'apps.customer.visitDetail',
    component: () => import('@/pages/apps/customer/visitDetail'),
    meta: {
      title: '访客详情'
    }
  },
  {
    path: '/apps/customer/edit',
    name: 'apps.customer.edit',
    component: () => import('@/pages/apps/customer/edit'),
    meta: {
      title: '编辑资料'
    }
  },
  {
    path: '/apps/customerInfo',
    name: 'apps.customerInfo',
    component: () => import('@/pages/apps/customer/customerInfo'),
    meta: {
      title: '客户信息'
    }
  },
  /*************** ok保客户管理 *******************/
  {
    path: '/apps/okbao/customer',
    name: 'apps.okbao.customer',
    component: () => import('@/pages/apps/okBao/customer/customer'),
    meta: {
      title: '客户管理',
      deepth: 2,
      keepAlive: true
    }
  },

  {
    path: '/apps/okbao/addCustomer',
    name: 'apps.okbao.addCustomer',
    component: () => import('@/pages/apps/okBao/customer/addCustomer'),
    meta: {
      title: ' ',
      deepth: 3
    }
  },

  /*************** ok保培训 *******************/
  {
    path: '/apps/okbao/course/courseDetails',
    name: 'apps.okBao.course.courseDetails',
    component: () => import('@/pages/apps/okBao/course/courseDetails'),
    meta: {
      title: '培训中心',
      rank: 2,
      deepth: 3
    }
  },
  /*************** ok保增员*******************/
  {
    path: '/apps/okbao/recruitingActivity',
    name: 'apps.okBao.recruitingActivity.index',
    component: () => import('@/pages/apps/okBao/recruitingActivity/index'),
    meta: {
      title: '增员专区'
    }
  },
  {
    path: '/apps/okbao/recruitingActivity/poster',
    name: 'apps.okbao.recruitingActivity.poster',
    component: () => import('@/pages/apps/okBao/recruitingActivity/poster'),
    meta: {
      title: '海报'
    }
  },
  {
    path: '/apps/okbao/recruitingActivity/imgageDetail',
    name: 'apps.okbao.recruitingActivity.imgageDetail',
    component: () => import('@/pages/apps/okBao/recruitingActivity/imgageDetail'),
    meta: {
      title: '详情'
    }
  },
  {
    path: '/apps/okbao/signRegister',
    name: 'apps.okBao.sign.init',
    component: () => import('@/pages/apps/okBao/sign/init-new'),
    meta: {
      title: ''
    }
  },
  {
    path: '/apps/okbao/signRegister1',
    name: 'apps.okBao.sign.init1',
    component: () => import('@/pages/apps/okBao/sign/init-new1'),
    meta: {
      title: ''
    }
  },
  {
    path: '/apps/okbao/signRegister2',
    name: 'apps.okBao.sign.init2',
    component: () => import('@/pages/apps/okBao/sign/init-new2'),
    meta: {
      title: ''
    }
  },
  /*************** 如意保保相关页面 *******************/

  {
    path: '/apps/rybb/register',
    name: 'apps.rybb.register',
    component: () => import('@/pages/apps/ruyibaobao/register'),
    meta: {
      title: '增员专区'
    }
  },
  {
    path: '/apps/rybb/register/info',
    name: 'apps.rybb.register.info',
    component: () => import('@/pages/apps/ruyibaobao/info'),
    meta: {
      title: '活动规则'
    }
  },
  /*************** 消息中心 *******************/
  {
    path: '/apps/notices',
    name: 'notices',
    component: () => import('@/pages/apps/notices/newNotices'),
    meta: {
      keepAlive: true,
      title: '消息中心'
    }
  },
  {
    path: '/apps/noticeList',
    name: 'noticeList',
    component: () => import('@/pages/apps/notices/noticeList'),
    meta: {
      keepAlive: true,
      title: '消息列表'
    }
  },
  {
    path: '/apps/notices/detail',
    name: 'notices.detail',
    component: () => import('@/pages/apps/notices/detail'),
    meta: {
      title: '消息详情'
    }
  },
  // 工单服务
  {
    path: '/apps/policys/startPolicy',
    name: 'apps.policys.startPolicy',
    component: () => import('@/pages/apps/policys/startPolicy'),
    meta: {
      title: '工单服务',
      deepth: 1
    }
  },
  {
    path: '/apps/policys/claim/list',
    name: 'apps.policys.claim.list',
    component: () => import('@/pages/apps/policys/claim/list'),
    meta: {
      title: '理赔记录',
      keepAlive: true,
      deepth: 2
    }
  },
  {
    path: '/apps/policys/claim/add',
    name: 'apps.policys.claim/add',
    component: () => import('@/pages/apps/policys/claim/add'),
    meta: {
      title: '新增理赔',
      deepth: 3
    }
  },
  {
    path: '/apps/policys/claim/form',
    name: 'apps.policys.claim/form',
    component: () => import('@/pages/apps/policys/claim/form'),
    meta: {
      title: '填写理赔信息',
      deepth: 3
    }
  },

  {
    path: '/apps/policys/paperPolicy/index',
    name: 'apps.policys.paperPolicy.index',
    component: () => import('@/pages/apps/policys/paperPolicy/index'),
    meta: {
      title: '纸质保单'
    }
  },
  {
    path: '/apps/policys/paperPolicy/saveInfo',
    name: 'apps.policys.paperPolicy/saveInfo',
    component: () => import('@/pages/apps/policys/paperPolicy/saveInfo.vue'),
    meta: {
      title: '信息填写'
    }
  },
  {
    path: '/apps/policys/paperPolicy/selectPolicy',
    name: 'apps.policys.paperPolicy/selectPolicy',
    component: () => import('@/pages/apps/policys/paperPolicy/selectPolicy.vue'),
    meta: {
      title: '选择保单'
    }
  },
  {
    path: '/apps/policys/paperPolicy/list',
    name: 'apps.policys.paperPolicy.list',
    component: () => import('@/pages/apps/policys/paperPolicy/list'),
    meta: {
      title: '进度查询',
      keepAlive: true,
      deepth: 2
    }
  },
  {
    path: '/apps/policys/paperPolicy/checkPolicy',
    name: 'apps.policys.paperPolicy.checkPolicy',
    component: () => import('@/pages/apps/policys/paperPolicy/checkPolicy'),
    meta: {
      title: '选择保单',
      keepAlive: true,
      deepth: 2
    }
  },
  {
    path: '/apps/policys/paperPolicy/sendMail',
    name: 'apps.policys.paperPolicy.sendMail',
    component: () => import('@/pages/apps/policys/paperPolicy/sendMail'),
    meta: {
      title: '填写邮寄信息'
    }
  },
  {
    path: '/apps/policys/paperPolicy/sendMailDetail',
    name: 'apps.policys.paperPolicy.sendMailDetail',
    component: () => import('@/pages/apps/policys/paperPolicy/sendMailDetail'),
    meta: {
      title: '邮寄进度详情',
      deepth: 3
    }
  },
  {
    path: '/apps/policys/paperPolicy/signList',
    name: 'apps.policys.paperPolicy/signList',
    component: () => import('@/pages/apps/policys/paperPolicy/signList.vue'),
    meta: {
      title: '纸质保单签收情况填写'
    }
  },
  {
    path: '/apps/policys/paperPolicy/signDetail',
    name: 'apps.policys.paperPolicy/signDetail',
    component: () => import('@/pages/apps/policys/paperPolicy/signDetail.vue'),
    meta: {
      title: '纸质保单签收情况填写'
    }
  },
  {
    path: '/apps/policys/paperPolicy/signDetailEdit',
    name: 'apps.policys.paperPolicy/signDetailEdit',
    component: () => import('@/pages/apps/policys/paperPolicy/signDetailEdit.vue'),
    meta: {
      title: '纸质保单签收情况填写'
    }
  },
  //理赔相关
  {
    path: '/apps/claims/detail',
    name: 'apps.claims.detail',
    component: () => import('@/pages/apps/claims/detail'),
    meta: {
      title: '理赔详情'
    }
  },
  {
    path: '/apps/claims/info',
    name: 'apps.claims.info',
    component: () => import('@/pages/apps/claims/info'),
    meta: {
      title: '填写理赔信息'
    }
  },
  {
    path: '/apps/kefu',
    name: 'apps.kefu',
    component: () => import('@/pages/apps/kefu/kefu'),
    meta: {
      title: '客服咨询'
    }
  },
  {
    path: '/apps/wxKefu',
    name: 'apps.wxKefu',
    component: () => import('@/pages/apps/kefu/wxKefu'),
    meta: {
      title: '专属微信客服'
    }
  },
  // 帮助中心
  {
    path: '/apps/help/help',
    name: 'apps.help',
    component: () => import('@/pages/apps/help/help'),
    meta: {
      title: '帮助中心'
    }
  },
  {
    path: '/apps/help/helpDetail',
    name: 'apps.helpDetail',
    component: () => import('@/pages/apps/help/helpDetail'),
    meta: {
      title: ''
    }
  },
  {
    path: '/apps/help/list',
    name: 'apps.list',
    component: () => import('@/pages/apps/help/list')
  },
  {
    path: '/apps/help/cooperation',
    name: 'apps.cooperation',
    component: () => import('@/pages/apps/help/cooperation'),
    meta: {
      title: '商务合作'
    }
  },
  // {
  // 	path: "/apps/signRegister",
  // 	name: "apps.signRegister",
  // 	component: () => import("@/pages/apps/sign/init"),
  // 	meta: {
  // 		title: "注册",
  // 	},
  // },
  // 新注册页
  {
    path: '/apps/signRegister',
    name: 'apps.signRegister',
    component: () => import('@/pages/apps/sign/init-new'),
    meta: {
      title: ''
    }
  },
  {
    path: '/apps/sign',
    component: () => import('@/pages/apps/sign/index'),
    meta: {
      title: '签约',
      rank: 1
    },
    children: [
      {
        path: 'register',
        component: () => import('@/pages/apps/sign/register'),
        meta: {
          title: '登记信息',
          rank: 1,
          index: 0
        }
      },
      {
        path: 'ok-register',
        component: () => import('@/pages/apps/sign/ok-register'),
        meta: {
          title: '登记信息',
          rank: 1,
          index: 0
        }
      },
      {
        path: 'face',
        component: () => import('@/pages/apps/sign/face'),
        meta: {
          title: '人脸识别',
          rank: 1,
          index: 1
        }
      },
      {
        path: 'train',
        component: () => import('@/pages/apps/sign/train'),
        meta: {
          title: '岗前培训',
          rank: 1,
          index: 2
        }
      },
      {
        path: 'trainTest',
        component: () => import('@/pages/apps/sign/trainTest'),
        meta: {
          title: '考试',
          rank: 1,
          index: 2
        }
      },
      {
        path: 'contract',
        component: () => import('@/pages/apps/sign/contract'),
        meta: {
          title: '签署合同',
          rank: 1,
          index: 3
        }
      },
      {
        path: 'success',
        component: () => import('@/pages/apps/sign/success'),
        meta: {
          title: '申请完成',
          rank: 1,
          index: 4
        }
      }
    ]
  },
  {
    path: '/apps/ok-sign',
    component: () => import('@/pages/apps/ok-sign/index'),
    meta: {
      title: '签约',
      rank: 1
    },
    children: [
      {
        path: 'ok-register',
        component: () => import('@/pages/apps/ok-sign/ok-register'),
        meta: {
          title: '登记信息',
          rank: 1,
          index: 0
        }
      },
      {
        path: 'ok-face',
        component: () => import('@/pages/apps/ok-sign/face'),
        meta: {
          title: '人脸识别',
          rank: 1,
          index: 1
        }
      },
      {
        path: 'ok-contract',
        component: () => import('@/pages/apps/ok-sign/contract'),
        meta: {
          title: '签署合同',
          rank: 1,
          index: 2
        }
      },
      {
        path: 'ok-train',
        component: () => import('@/pages/apps/ok-sign/train'),
        meta: {
          title: '岗前培训',
          rank: 1,
          index: 3
        }
      },
      {
        path: 'trainTest',
        component: () => import('@/pages/apps/ok-sign/trainTest'),
        meta: {
          title: '考试',
          rank: 1,
          index: 3
        }
      }
    ]
  },
  {
    path: '/apps/ok-sign/result',
    component: () => import('@/pages/apps/ok-sign/result'),
    meta: {
      title: ''
    }
  },
  {
    path: '/apps/sign/groupProductTrain',
    component: () => import('@/pages/apps/sign/groupProductTrain'),
    meta: {
      title: '岗前培训'
    }
  },
  {
    path: '/apps/sign/groupProductTrainDetail',
    component: () => import('@/pages/apps/sign/groupProductTrainDetail'),
    meta: {
      title: '课程详情'
    }
  },
  {
    path: '/apps/sign/groupProductTrainTest',
    component: () => import('@/pages/apps/sign/groupProductTrainTest'),
    meta: {
      title: '考试'
    }
  },
  {
    path: '/apps/sign/groupProductTrainSuccess',
    component: () => import('@/pages/apps/sign/groupProductTrainSuccess'),
    meta: {
      title: '申请完成'
    }
  },
  {
    path: '/apps/sign/end',
    component: () => import('@/pages/apps/sign/end'),
    meta: {
      title: '入职成功'
    }
  },
  {
    path: '/apps/sign/result',
    component: () => import('@/pages/apps/sign/result'),
    meta: {
      title: '在线入职'
    }
  },
  {
    path: '/apps/sign/education',
    component: () => import('@/pages/apps/sign/education'),
    meta: {
      title: '学历证书完善'
    }
  },
  {
    path: '/apps/sign/leaflet',
    component: () => import('@/pages/apps/sign/leaflet'),
    meta: {
      title: '立即签约'
    }
  },
  {
    path: '/apps/sign/takePhoto',
    name: 'apps.takePhoto',
    component: () => import('@/pages/apps/sign/components/takePhoto'),
    meta: {
      title: '登记信息'
    }
  },
  {
    path: '/apps/sign/trainDetail',
    component: () => import('@/pages/apps/sign/trainDetail'),
    meta: {
      title: '课程详情'
    }
  },
  /**************************** 展业素材-新 **************************************/
  {
    path: '/apps/exhibitionMaterial',
    name: 'apps.exhibitionMaterial',
    component: () => import('@/pages/apps/exhibitionMaterial/index'),
    meta: {
      title: '展业素材',
      keepAlive: true
    }
  },
  /**************************** 外链H5页面 **************************************/
  // 申请处理详情页
  {
    path: '/apps/markets/submitProLink',
    name: 'apps.markets.submitProLink',
    component: () => import('@/pages/apps/markets/submitProLink'),
    meta: {
      title: '投保申请处理'
    }
  },
  // 处理成功
  {
    path: '/apps/markets/submitSuccess',
    name: 'apps.markets.submitSuccess',
    component: () => import('@/pages/apps/markets/submitSuccess'),
    meta: {
      title: '投保申请处理'
    }
  },
  // 在企业微信以外的页面打开提示页
  {
    path: '/apps/markets/tipsPage',
    name: 'apps.markets.tipsPage',
    component: () => import('@/pages/apps/markets/tipsPage'),
    meta: {
      title: '投保申请处理'
    }
  },
  // 待处理列表
  {
    path: '/apps/markets/pendList',
    name: 'apps.markets.pendList',
    component: () => import('@/pages/apps/markets/pendList'),
    meta: {
      title: '投保申请处理'
    }
  },
  // 展业中心
  {
    path: '/apps/business/home',
    name: 'apps.business.home',
    component: () => import('@/pages/apps/business/home'),
    meta: {
      title: '展业中心',
      deepth: 1
    }
  },
  // 客户管理
  {
    path: '/apps/business/customer',
    name: 'apps.business.customer',
    component: () => import('@/pages/apps/business/customer'),
    meta: {
      title: '我的客户',
      keepAlive: true,
      deepth: 2
    }
  },
  {
    path: '/apps/business/importCustomer',
    name: 'apps.business.importCustomer',
    component: () => import('@/pages/apps/business/importCustomer'),
    meta: {
      title: '通讯录导入',
      deepth: 3
    }
  },
  {
    path: '/apps/business/addCustomer',
    name: 'apps.business.addCustomer',
    component: () => import('@/pages/apps/business/addCustomer'),
    meta: {
      title: ' ',
      deepth: 3
    }
  },
  {
    path: '/apps/business/customerDetail',
    name: 'apps.business.customerDetail',
    component: () => import('@/pages/apps/business/customerDetail'),
    meta: {
      title: '客户详情',
      keepAlive: true,
      deepth: 3
    }
  },
  {
    path: '/apps/business/customerInfoDetail',
    name: 'apps.business.customerInfoDetail',
    component: () => import('@/pages/apps/business/customerInfoDetail'),
    meta: {
      title: '预约记录',
      keepAlive: true,
      deepth: 3
    }
  },
  {
    path: '/apps/business/familyList',
    name: 'apps.business.familyList',
    component: () => import('@/pages/apps/business/familyList'),
    meta: {
      title: ' '
    }
  },
  {
    path: '/apps/business/visitor',
    name: 'apps.business.visitor',
    component: () => import('@/pages/apps/business/visitor'),
    meta: {
      title: '我的访客',
      keepAlive: true,
      deepth: 2
    }
  },
  {
    path: '/apps/business/visitorDetail',
    name: 'apps.business.visitorDetail',
    component: () => import('@/pages/apps/business/visitorDetail'),
    meta: {
      title: '访客详情',
      deepth: 3
    }
  },
  {
    path: '/apps/business/contentVisitDetail',
    name: 'apps.business.contentVisitDetail',
    component: () => import('@/pages/apps/business/contentVisitDetail'),
    meta: {
      title: '访客详情'
    }
  },
  {
    path: '/apps/business/followDetail',
    name: 'apps.business.followDetail',
    component: () => import('@/pages/apps/business/followDetail'),
    meta: {
      title: '跟进',
      deepth: 4
    }
  },
  {
    path: '/apps/business/addMember',
    name: 'apps.business.addMember',
    component: () => import('@/pages/apps/business/addMember'),
    meta: {
      title: ' '
    }
  },
  {
    path: '/apps/business/searchVisitor',
    name: 'apps.business.searchVisitor',
    component: () => import('@/pages/apps/business/searchVisitor'),
    meta: {
      title: '访客搜索',
      keepAlive: true,
      deepth: 3
    }
  },
  {
    path: '/apps/business/searchCustomer',
    name: 'apps.business.searchCustomer',
    component: () => import('@/pages/apps/business/searchCustomer'),
    meta: {
      title: '搜索客户'
    }
  },
  {
    path: '/apps/business/bindCustomer',
    name: 'apps.business.bindCustomer',
    component: () => import('@/pages/apps/business/bindCustomer'),
    meta: {
      title: ' '
    }
  },
  {
    path: '/apps/business/orderList',
    name: 'apps.business.orderList',
    component: () => import('@/pages/apps/business/orderList'),
    meta: {
      title: '成交单'
    }
  },
  /*************** 预约顾问 *******************/
  {
    path: '/apps/appointment',
    name: 'apps.appointment',
    component: () => import('@/pages/apps/appointment'),
    meta: {
      title: '预约顾问'
    }
  },
  /*************** 名片管理 *******************/
  {
    path: '/apps/businessCard',
    name: 'businessCard',
    component: () => import('@/pages/apps/businessCard/businessCard.vue'),
    meta: {
      title: '我的名片'
    }
  },
  {
    path: '/apps/editBusinessCard',
    name: 'editBusinessCard',
    component: () => import('@/pages/apps/businessCard/editBusinessCard.vue'),
    meta: {
      title: '编辑个人名片'
    }
  },
  {
    path: '/apps/course/searchList',
    name: 'apps.course.searchList',
    component: () => import('@/pages/apps/course/searchList.vue'),
    meta: {
      title: '课程搜索',
      keepAlive: true,
      deepth: 2
    }
  },
  {
    path: '/apps/userGuide',
    name: 'userGuide',
    component: () => import('@/pages/apps/businessCard/userGuide.vue'),
    meta: {
      title: '经营指南'
    }
  },
  {
    path: '/apps/renewal',
    name: 'apps.renewal',
    component: () => import('@/pages/apps/renewal/index.vue'),
    meta: {
      title: '续期续保管理',
      keepAlive: true,
      deepth: 1
    }
  },
  {
    path: '/apps/renewal/detail',
    name: 'apps.renewal.detail',
    component: () => import('@/pages/apps/renewal/detail.vue'),
    meta: {
      title: '详情',
      keepAlive: true,
      deepth: 2
    }
  },
  {
    path: '/apps/renewal/detailGroup',
    name: 'apps.renewal.detailGroup',
    component: () => import('@/pages/apps/renewal/detailGroup.vue'),
    meta: {
      title: '详情',
      keepAlive: true,
      deepth: 2
    }
  },
  {
    path: '/apps/renewal/payFeeRecord',
    name: 'apps.renewal.payFeeRecord',
    component: () => import('@/pages/apps/renewal/payFeeRecord.vue'),
    meta: {
      title: '交费记录'
    }
  },
  /*************** 活动中心 *******************/
  // 活动中转页
  {
    path: '/apps/activityCenter/okApp/activityRedirect',
    name: 'apps.activityRedirect',
    component: () => import('@/pages/apps/activityCenter/okApp/activityRedirect.vue'),
    meta: {
      title: '加载中...'
    }
  },
  {
    path: '/apps/activityCenter',
    name: 'apps.activityCenter',
    component: () => import('@/pages/apps/activityCenter/index.vue'),
    meta: {
      title: '活动中心'
    }
  },
  {
    path: '/apps/activityDetail',
    name: 'apps.activityDetail',
    component: () => import('@/pages/apps/activityCenter/activityDetail.vue'),
    meta: {
      title: '活动详情',
      keepAlive: true,
      deepth: 3
    }
  },
  {
    path: '/apps/activity/okApp/activityCenter',
    name: 'apps.okApp.activityCenter',
    component: () => import('@/pages/apps/activityCenter/okApp/activityCenter.vue'),
    meta: {
      title: '活动中心'
    }
  },
  {
    path: '/apps/activity/okApp/activityCenterHistory',
    name: 'apps.okApp.activityCenterHistory',
    component: () => import('@/pages/apps/activityCenter/okApp/activityCenterHistory.vue'),
    meta: {
      title: '历史活动'
    }
  },
  {
    path: '/apps/activityCashDetail',
    name: 'apps.activityCashDetail',
    component: () => import('@/pages/apps/activityCenter/activityCashDetail.vue'),
    meta: {
      title: '活动详情-梯度-现金',
      keepAlive: true,
      deepth: 3
    }
  },
  {
    path: '/apps/partakeList',
    name: 'apps.partakeList',
    component: () => import('@/pages/apps/activityCenter/partakeList.vue'),
    meta: {
      title: '参与详情'
    }
  },
  {
    path: '/apps/partakeDetail',
    name: 'apps.partakeDetail',
    component: () => import('@/pages/apps/activityCenter/partakeDetail.vue'),
    meta: {
      title: '参与详情'
    }
  },
  {
    path: '/apps/inviteList',
    name: 'apps.inviteList',
    component: () => import('@/pages/apps/activityCenter/inviteList.vue'),
    meta: {
      title: '参与详情'
    }
  },
  {
    path: '/apps/okActivityDetail',
    name: 'apps.okActivityDetail',
    component: () => import('@/pages/apps/activityCenter/okActivityDetail.vue'),
    meta: {
      title: '活动详情'
    }
  },
  {
    path: '/apps/mailingAddress',
    name: 'apps.mailingAddress',
    component: () => import('@/pages/apps/activityCenter/mailingAddress.vue'),
    meta: {
      title: '邮寄地址'
    }
  },
  {
    path: '/apps/okLeaflets',
    name: 'apps.okLeaflets',
    component: () => import('@/pages/apps/activityCenter/okLeaflets.vue'),
    meta: {
      title: '邀请好友'
    }
  },
  {
    path: '/apps/activityCenter/okApp/recruitingActivity',
    name: 'apps.activityCenter.okApp.recruitingActivity',
    component: () => import('@/pages/apps/activityCenter/okApp/recruitingActivity/index.vue'),
    meta: {
      title: '邀请好友'
    }
  },
  {
    path: '/apps/activityCenter/okApp/recruitingActivityNew',
    name: 'apps.activityCenter.okApp.recruitingActivityNew',
    component: () => import('@/pages/apps/activityCenter/okApp/recruitingActivityNew/index.vue'),
    meta: {
      title: '邀请好友'
    }
  },
  {
    path: '/apps/activityCenter/okApp/partnershipRule',
    name: 'apps.activityCenter.okApp.partnershipRule',
    component: () => import('@/pages/apps/activityCenter/okApp/partnershipRule/index.vue'),
    meta: {
      title: '合伙人规则'
    }
  },
  {
    path: '/apps/activityCenter/okApp/recruitingActivity/myAddition',
    name: 'apps.activityCenter.okApp.recruitingActivity.myAddition',
    component: () => import('@/pages/apps/activityCenter/okApp/recruitingActivity/myAddition.vue'),
    meta: {
      title: '我的增员'
    }
  },
  {
    path: '/apps/activityCenter/okApp/recruitingActivity/contributionDetail',
    name: 'apps.activityCenter.okApp.recruitingActivity.contributionDetail',
    component: () => import('@/pages/apps/activityCenter/okApp/recruitingActivity/contributionDetail.vue'),
    meta: {
      title: '贡献明细'
    }
  },
  {
    path: '/apps/activityCenter/okActivity',
    name: 'apps.activityCenter.okLeaflets',
    component: () => import('@/pages/apps/activityCenter/okApp/202312.vue'),
    meta: {
      title: '开门红'
    }
  },
  {
    path: '/apps/activityCenter/202401',
    name: 'apps.202401',
    component: () => import('@/pages/apps/activityCenter/okApp/202401.vue'),
    meta: {
      title: '开门红'
    }
  },
  // {
  // 	path: "/apps/activityCenter/202402",
  // 	name: "apps.202402",
  // 	component: () => import("@/pages/apps/activityCenter/okApp/202402.vue"),
  // 	meta: {
  // 	  title: "邀好友-领现金大奖",
  // 	}
  // },
  // {
  // 	path: "/apps/activityCenter/202402Face",
  // 	name: "apps.202402.face",
  // 	component: () => import("@/pages/apps/activityCenter/okApp/202402Face.vue"),
  // 	meta: {
  // 	  title: "人脸识别",
  // 	}
  // },
  // {
  // 	path:'/apps/activityCenter/downloadApp',
  // 	name: "apps.202402.download.app",
  // 	component: () => import("@/pages/apps/activityCenter/okApp/202402DownloadApp.vue"),
  // 	meta: {
  // 	  title: "快来帮我助力，加速提现！",
  // 	}
  // },
  // {
  // 	path: "/apps/activityCenter/202402InviteList",
  // 	name: "apps.202401",
  // 	component: () => import("@/pages/apps/activityCenter/okApp/202402InviteList.vue"),
  // 	meta: {
  // 	  title: "参与详情",
  // 	}
  // },
  {
    path: '/apps/activityCenter/okApp/202403/01',
    name: 'apps.okApp.202403.01',
    component: () => import('@/pages/apps/activityCenter/okApp/202403/01'),
    meta: {
      title: '3月增员活动'
    }
  },
  {
    path: '/apps/activityCenter/okApp/202403/myPrizeDetail',
    name: 'apps.okApp.202403.my.prize.detail',
    component: () => import('@/pages/apps/activityCenter/okApp/202403/myPrizeDetail'),
    meta: {
      title: '我的奖品'
    }
  },
  {
    path: '/apps/activityCenter/okApp/202403/202403Face',
    name: 'apps.202403.face',
    component: () => import('@/pages/apps/activityCenter/okApp/202403/202403Face.vue'),
    meta: {
      title: '人脸识别'
    }
  },
  {
    path: '/apps/activityCenter/okApp/202403/02',
    name: 'apps.okApp.202403.02',
    component: () => import('@/pages/apps/activityCenter/okApp/202403/02'),
    meta: {
      title: '3月开单活动'
    }
  },
  {
    path: '/apps/activityCenter/okApp/202403/littleRedBook',
    name: 'apps.okApp.202403.banner',
    component: () => import('@/pages/apps/activityCenter/okApp/202403/littleRedBook'),
    meta: {
      title: '招募小红书种草官'
    }
  },
  {
    path: '/apps/activityCenter/okApp/202403/202403RedBookFace',
    name: 'apps.202403.RedBookFace',
    component: () => import('@/pages/apps/activityCenter/okApp/202403/202403RedBookFace.vue'),
    meta: {
      title: '人脸识别'
    }
  },
  {
    path: '/apps/activityCenter/okApp/202404/01',
    name: 'apps.okApp.202404.01',
    component: () => import('@/pages/apps/activityCenter/okApp/202404/01'),
    meta: {
      title: '爆单狂欢，好礼送不停'
    }
  },
  {
    path: '/apps/activityCenter/okApp/202404/myPrizeDetail',
    name: 'apps.okApp.202404.myPrizeDetail',
    component: () => import('@/pages/apps/activityCenter/okApp/202404/01MyPrizeDetail'),
    meta: {
      title: '我的奖品'
    }
  },
  {
    path: '/apps/activityCenter/okApp/202404/activityProductList',
    name: 'apps.okApp.202404.activityProductList',
    component: () => import('@/pages/apps/activityCenter/okApp/202404/activityProductList'),
    meta: {
      title: '活动产品清单'
    }
  },
  {
    path: '/apps/activityCenter/okApp/202404/02',
    name: 'apps.okApp.202404.02',
    component: () => import('@/pages/apps/activityCenter/okApp/202404/02'),
    meta: {
      title: '招募OK保推广大使'
    }
  },
  {
    path: '/apps/activityCenter/okApp/202404/02RedBookFace',
    name: 'apps.okApp.202404.02RedBookFace',
    component: () => import('@/pages/apps/activityCenter/okApp/202404/02RedBookFace'),
    meta: {
      title: '人脸识别'
    }
  },
  {
    path: '/apps/activityCenter/okApp/202404/02RewardDetail',
    name: 'apps.okApp.202404.02RewardDetail',
    component: () => import('@/pages/apps/activityCenter/okApp/202404/02RewardDetail'),
    meta: {
      title: '奖励明细'
    }
  },
  {
    path: '/apps/activityCenter/okApp/202404/03',
    name: 'apps.okApp.202404.03',
    component: () => import('@/pages/apps/activityCenter/okApp/202404/03'),
    meta: {
      title: '星之保专场福利'
    }
  },
  {
    path: '/apps/activityCenter/okApp/202404/04',
    name: 'apps.okApp.202404.04',
    component: () => import('@/pages/apps/activityCenter/okApp/202404/04'),
    meta: {
      title: '4月团财开单季'
    }
  },
  {
    path: '/apps/activityCenter/okApp/202405/01',
    name: 'apps.okApp.202405.01',
    component: () => import('@/pages/apps/activityCenter/okApp/202405/01'),
    meta: {
      title: '签到'
    }
  },
  {
    path: '/apps/activityCenter/okApp/202405/02',
    name: 'apps.okApp.202405.02',
    component: () => import('@/pages/apps/activityCenter/okApp/202405/02'),
    meta: {
      title: '518保险节，增员赚钱嗨翻天'
    }
  },
  {
    path: '/apps/activityCenter/okApp/202405/02Detail',
    name: 'apps.okApp.202405.02Detail',
    component: () => import('@/pages/apps/activityCenter/okApp/202405/02Detail'),
    meta: {
      title: '参与详情'
    }
  },
  {
    path: '/apps/activityCenter/okApp/202405/03',
    name: 'apps.okApp.202405.03',
    component: () => import('@/pages/apps/activityCenter/okApp/202405/03'),
    meta: {
      title: '518保险节，开单财富滚滚来'
    }
  },
  {
    path: '/apps/activityCenter/okApp/202405/03LongProductList',
    name: 'apps.okApp.202405.03LongProductList',
    component: () => import('@/pages/apps/activityCenter/okApp/202405/03LongProductList'),
    meta: {
      title: '产品活动清单'
    }
  },
  {
    path: '/apps/activityCenter/okApp/202405/03ShortProductList',
    name: 'apps.okApp.202405.03ShortProductList',
    component: () => import('@/pages/apps/activityCenter/okApp/202405/03ShortProductList'),
    meta: {
      title: '短险产品活动清单'
    }
  },
  {
    path: '/apps/activityCenter/okApp/202405/04',
    name: 'apps.okApp.202405.04',
    component: () => import('@/pages/apps/activityCenter/okApp/202405/04'),
    meta: {
      title: '5月团财开单季'
    }
  },
  {
    path: '/apps/activityCenter/okApp/202406/01',
    name: 'apps.okApp.202406.01',
    component: () => import('@/pages/apps/activityCenter/okApp/202406/01'),
    meta: {
      title: '瓜分61.8万现金大奖'
    }
  },
  {
    path: '/apps/activityCenter/okApp/202406/02',
    name: 'apps.okApp.202406.02',
    component: () => import('@/pages/apps/activityCenter/okApp/202406/02'),
    meta: {
      title: '邀好友=现金奖'
    }
  },
  {
    path: '/apps/activityCenter/okApp/202406/03',
    name: 'apps.okApp.202406.03',
    component: () => import('@/pages/apps/activityCenter/okApp/202406/03'),
    meta: {
      title: '招募OK保种草达人'
    }
  },
  {
    path: '/apps/activityCenter/okApp/202406/04',
    name: 'apps.okApp.202406.04',
    component: () => import('@/pages/apps/activityCenter/okApp/202406/04'),
    meta: {
      title: '瓜分61.8万现金大奖'
    }
  },
  {
    path: '/apps/activityCenter/okApp/202407/01',
    name: 'apps.okApp.202407.01',
    component: () => import('@/pages/apps/activityCenter/okApp/202407/01'),
    meta: {
      title: '开单赢大奖'
    }
  },
  {
    path: '/apps/activityCenter/okApp/202407/02',
    name: 'apps.okApp.202407.02',
    component: () => import('@/pages/apps/activityCenter/okApp/202407/02'),
    meta: {
      title: '邀好友奖不停'
    }
  },
  {
    path: '/apps/activityCenter/okApp/202407/02Detail',
    name: 'apps.okApp.202407.02Detail',
    component: () => import('@/pages/apps/activityCenter/okApp/202407/02Detail'),
    meta: {
      title: '参与详情'
    }
  },
  {
    path: '/apps/activityCenter/okApp/202407/03',
    name: 'apps.okApp.202407.03',
    component: () => import('@/pages/apps/activityCenter/okApp/202407/03'),
    meta: {
      title: '招募OK保种草达人'
    }
  },
  {
    path: '/apps/activityCenter/okApp/202408/01',
    name: 'apps.okApp.202408.01',
    component: () => import('@/pages/apps/activityCenter/okApp/202408/01'),
    meta: {
      title: '开单赢大奖'
    }
  },
  {
    path: '/apps/activityCenter/okApp/202408/02',
    name: 'apps.okApp.202408.02',
    component: () => import('@/pages/apps/activityCenter/okApp/202408/02'),
    meta: {
      title: '邀好友奖不停'
    }
  },
  {
    path: '/apps/activityCenter/okApp/202408/03',
    name: 'apps.okApp.202408.03',
    component: () => import('@/pages/apps/activityCenter/okApp/202408/03'),
    meta: {
      title: '招募OK保种草达人'
    }
  },
  {
    path: '/apps/activityCenter/okApp/202408/04',
    name: 'apps.okApp.202408.04',
    component: () => import('@/pages/apps/activityCenter/okApp/202408/04'),
    meta: {
      title: '团险单单奖现金'
    }
  },
  {
    path: '/apps/activityCenter/okApp/202408/05',
    name: 'apps.okApp.202408.05',
    component: () => import('@/pages/apps/activityCenter/okApp/202408/05'),
    meta: {
      title: '签约有奖 即刻行动'
    }
  },
  {
    path: '/apps/activityCenter/okApp/202409/01',
    name: 'apps.okApp.202409.01',
    component: () => import('@/pages/apps/activityCenter/okApp/202409/01'),
    meta: {
      title: '开单赢大奖'
    }
  },
  {
    path: '/apps/activityCenter/okApp/202409/02',
    name: 'apps.okApp.202409.02',
    component: () => import('@/pages/apps/activityCenter/okApp/202409/02'),
    meta: {
      title: '邀好友奖不停'
    }
  },
  {
    path: '/apps/activityCenter/okApp/202409/04',
    name: 'apps.okApp.202409.04',
    component: () => import('@/pages/apps/activityCenter/okApp/202409/04'),
    meta: {
      title: '团险单单奖现金'
    }
  },
  {
    path: '/apps/activityCenter/okApp/202409/05',
    name: 'apps.okApp.202409.05',
    component: () => import('@/pages/apps/activityCenter/okApp/202409/05'),
    meta: {
      title: '签约有奖 即刻行动'
    }
  },
  {
    path: '/apps/activityCenter/okApp/202410/01',
    name: 'apps.okApp.202410.01',
    component: () => import('@/pages/apps/activityCenter/okApp/202410/01'),
    meta: {
      title: '开单赢大奖'
    }
  },
  {
    path: '/apps/activityCenter/okApp/202410/02',
    name: 'apps.okApp.202410.02',
    component: () => import('@/pages/apps/activityCenter/okApp/202410/02'),
    meta: {
      title: '邀好友奖不停'
    }
  },
  {
    path: '/apps/activityCenter/okApp/202410/04',
    name: 'apps.okApp.202410.04',
    component: () => import('@/pages/apps/activityCenter/okApp/202410/04'),
    meta: {
      title: '团险单单奖现金'
    }
  },
  {
    path: '/apps/activityCenter/okApp/202410/05',
    name: 'apps.okApp.202410.05',
    component: () => import('@/pages/apps/activityCenter/okApp/202410/05'),
    meta: {
      title: '签约有奖 即刻行动'
    }
  },
  {
    path: '/apps/activityCenter/okApp/202412/01',
    name: 'apps.okApp.202412.01',
    component: () => import('@/pages/apps/activityCenter/okApp/202412/01'),
    meta: {
      title: '开单赢大奖'
    }
  },
  {
    path: '/apps/activityCenter/okApp/20241012',
    name: 'apps.okApp.20241012.index',
    component: () => import('@/pages/apps/activityCenter/okApp/20241012/index'),
    meta: {
      title: '桐鹰计划 蓄势待发'
    }
  },
  {
    path: '/apps/activityCenter/okApp/202501/01',
    name: 'apps.okApp.202501.01',
    component: () => import('@/pages/apps/activityCenter/okApp/202501/01'),
    meta: {
      title: '开单赢大奖'
    }
  },
  {
    path: '/apps/activityCenter/okApp/202503/01',
    name: 'apps.okApp.202503.01',
    component: () => import('@/pages/apps/activityCenter/okApp/202503/01'),
    meta: {
      title: '春日有礼 爆单来袭'
    }
  },
  {
    path: '/apps/activityCenter/okApp/202503/04',
    name: 'apps.okApp.202503.04',
    component: () => import('@/pages/apps/activityCenter/okApp/202503/04'),
    meta: {
      title: '团险开工季每单奖不停'
    }
  },
  {
    path: '/apps/activityCenter/okApp/202504/01',
    name: 'apps.okApp.202504.01',
    component: () => import('@/pages/apps/activityCenter/okApp/202504/01'),
    meta: {
      title: '春日有礼 爆单来袭'
    }
  },
  {
    path: '/apps/activityCenter/okApp/202504/04',
    name: 'apps.okApp.202504.04',
    component: () => import('@/pages/apps/activityCenter/okApp/202504/04'),
    meta: {
      title: '团险开工季每单奖不停'
    }
  },
  {
    path: '/apps/activityCenter/okApp/202505/01',
    name: 'apps.okApp.202505.01',
    component: () => import('@/pages/apps/activityCenter/okApp/202505/01'),
    meta: {
      title: '春日有礼 爆单来袭'
    }
  },
  {
    path: '/apps/activityCenter/okApp/202505/04',
    name: 'apps.okApp.202505.05',
    component: () => import('@/pages/apps/activityCenter/okApp/202505/04'),
    meta: {
      title: '团险开工季每单奖不停'
    }
  },
  {
    path: '/apps/activityCenter/okApp/202506/01',
    name: 'apps.okApp.202506.01',
    component: () => import('@/pages/apps/activityCenter/okApp/202506/01'),
    meta: {
      title: '钞能力献礼 燃爆618'
    }
  },
  {
    path: '/apps/activityCenter/okApp/202507/01',
    name: 'apps.okApp.202507.01',
    component: () => import('@/pages/apps/activityCenter/okApp/202507/01'),
    meta: {
      title: '清爽一夏福利享不停'
    }
  },
  {
    path: '/apps/activityCenter/okApp/202508/01',
    name: 'apps.okApp.202508.01',
    component: () => import('@/pages/apps/activityCenter/okApp/202508/01'),
    meta: {
      title: '暑期狂欢N多福利享不停'
    }
  },
  {
    path: '/apps/activityCenter/okApp/20241012/form',
    name: 'apps.okApp.20241012.form',
    component: () => import('@/pages/apps/activityCenter/okApp/20241012/form'),
    meta: {
      title: '桐鹰计划 蓄势待发'
    }
  },
  {
    path: '/apps/daily',
    name: 'daily.index',
    component: () => import('@/pages/apps/daily/index.vue'),
    meta: {
      title: '日程助理',
      keepAlive: true,
      deepth: 2
    }
  },
  {
    path: '/apps/daily/trainingDetail',
    name: 'daily.trainingDetail',
    component: () => import('@/pages/apps/daily/trainingDetail.vue'),
    meta: {
      title: '培训详情',
      keepAlive: true,
      deepth: 3
    }
  },
  {
    path: '/apps/daily/activityDetail',
    name: 'daily.activityDetail',
    component: () => import('@/pages/apps/daily/activityDetail.vue'),
    meta: {
      title: '活动详情',
      keepAlive: true,
      deepth: 3
    }
  },
  /*************** 赠险相关 *******************/
  {
    path: '/apps/giveawayProduct/index',
    name: 'apps.giveawayProduct.index',
    component: () => import('@/pages/apps/giveawayProduct/index'),
    meta: {
      title: '赠险',
      rank: 1,
      keepAlive: true
    }
  },
  {
    path: '/apps/giveawayProduct/orderList',
    name: 'apps.giveawayProduct.orderList',
    component: () => import('@/pages/apps/giveawayProduct/orderList'),
    meta: {
      title: '赠险',
      rank: 2,
      keepAlive: true
    }
  },
  {
    path: '/apps/giveawayProduct/search',
    name: 'order.giveawayProduct.search',
    component: () => import('@/pages/apps/giveawayProduct/search'),
    meta: {
      title: '赠险',
      deepth: 3,
      keepAlive: true
    }
  },
  {
    path: '/apps/giveawayProduct/order/search',
    name: 'order.giveawayProduct.order.search',
    component: () => import('@/pages/apps/order/giveaway/search'),
    meta: {
      title: '赠险'
    }
  },
  {
    path: '/apps/order/qualityTesting',
    name: 'order.qualityTesting',
    component: () => import('@/pages/apps/order/qualityTesting.vue'),
    meta: {
      title: '质检单',
      deepth: 2,
      keepAlive: true
    }
  },
  {
    path: '/apps/notices/dissolution',
    name: 'notices.dissolution',
    component: () => import('@/pages/apps/notices/dissolution.vue'),
    meta: {
      title: '单方解除协议通知书',
    }
  },
  /*************** 上游工号 *******************/
  {
    path: '/apps/upWk',
    name: 'order.upWk',
    component: () => import('@/pages/apps/upWk/list.vue'),
    meta: {
      title: '上游工号',
      deepth: 2,
      keepAlive: true
    }
  },
  {
    path: '/',
    redirect: '/apps/index'
  }
];

const router = new VueRouter({
  mode: 'history',
  routes
});
// 全局前置守卫
router.beforeEach((to, from, next) => {
  tools.setWebTitle(to.meta.title);
  next();
});
router.afterEach((to, from) => {
  // 处理ios分享不支持history问题
  if (tools.isIOS() && !window.entryUrl) {
    window.entryUrl = location.href.split('#')[0];
  }
  // 订单页调用APP会崩 特殊处理
  if (common.isApp && to.name != 'order.order.index') {
    appTools.hideRightIcon();
  }
  // if (to.path === "/headlines") {
  //   console.log('路由钩子执行。。。')
  //   weixin.share()
  // }
});
export default router;
